import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'
import sessionStorage from 'redux-persist/es/storage/session'
import bookingSlice from './slices/booking'

const bookingPersistConfig = {
  key: 'booking',
  storage: sessionStorage,
}

const persistedBookingReducer = persistReducer(
  bookingPersistConfig,
  bookingSlice
)

const store = configureStore({
  reducer: {
    booking: persistedBookingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export const persistor = persistStore(store)
export default store
